module.exports = __webpack_public_path__ + "img/detail_01.d4bb239f.png";